import { useState } from "react";

// material UI Components
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

import { BUTTONS } from "./constants";
import Onboarding from "../../onboarding";

export const Footer = (): JSX.Element => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <Stack direction="row" spacing={2} justifyContent="center" mt={8}>
      <Button onClick={() => setModalVisible(true)}>
        <a>{BUTTONS.KNOW_MORE}</a>
      </Button>
      <Divider orientation="vertical" variant="middle" flexItem />
      <Button>
        <a
          href="https://waffyapp.com/terms-of-service-ar/"
          target="_blank"
          style={{
            textDecoration: "none",
            color: "#1976d2",
          }}
          rel="noreferrer">
          {BUTTONS.TERMS_AND_CONDITIONS}
        </a>
      </Button>
      <Modal
        open={modalVisible}
        onClose={() => {
          setModalVisible(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <Box
          style={{
            backgroundColor: "white",
            padding: "0.5rem",
            borderRadius: "0.5rem",
          }}>
          <Onboarding />
        </Box>
      </Modal>
    </Stack>
  );
};
